// extracted by mini-css-extract-plugin
export default {"resetButton":"z8RH_IC","nodeContent":"GZcdIxk","nodeTitle":"V7PhkZ7","nodesModeBtn":"NbLifyp"};